import React from 'react';
import PropTypes from 'prop-types';
import { getDarkMode } from 'selectors/theme';
import { connect } from 'react-redux';
import './ImageButton.css';

function ImageButton(props) {
  const handleClick = (event) => {
    event.stopPropagation();
    if (props.onClick && !props.disabled) {
      props.onClick();
    }
  };

  const src = props.darkMode && props.darkSrc ? props.darkSrc : props.src;

  return (
    <img
      alt={props.alt}
      title={props.title || props.alt}
      className={`image-button${props.disabled ? ' disabled' : ''}`}
      src={src}
      onClick={handleClick}
    />
  );
}

ImageButton.propTypes = {
  alt: PropTypes.string.isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  src: PropTypes.string.isRequired,
  darkSrc: PropTypes.string,
  darkMode: PropTypes.bool,
  onClick: PropTypes.func,
};

ImageButton.defaultProps = {
  disabled: false,
  darkMode: false,
};

export default connect((state) => ({ darkMode: getDarkMode(state) }))(
  ImageButton
);
